// テスト用コメント - プロトタイプデザイン適用テスト
import React, { useState } from 'react';
import { useWeddingContext } from '../context/WeddingContext';
import EditTaskModal from './EditTaskModal';
import { Task } from '../types';

const Dashboard: React.FC = () => {
  const { tasks = [] } = useWeddingContext();
  const [editingTask, setEditingTask] = useState<Task | null>(null);

  // 緊急タスクの計算
  const calculateUrgentTasks = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    //期限切れタスク
    const overdueTasks = tasks.filter(task => {
      if (!task.dueDate || task.status === '完了') return false;
      const dueDate = new Date(task.dueDate);
      return dueDate < today;
    });
    //今日から今週期限のタスク
    const endOfWeek = new Date(today);
    endOfWeek.setDate(today.getDate() + (6 - today.getDay()));
    const thisWeekDueTasks = tasks.filter(task => {
      if (!task.dueDate || task.status === '完了') return false;
      const dueDate = new Date(task.dueDate);
      return dueDate >= today && dueDate <= endOfWeek;
    });

   // 重要度高で未完了のタスク
    // 重要度高で未完了、かつ2ヶ月以内期限のタスク
    const twoMonthsLater = new Date(today);
    twoMonthsLater.setMonth(today.getMonth() + 2);
    
    const highPriorityTasks = tasks.filter(task => {
      if (task.status === '完了') return false;
      if (!(task.priority === '高' || task.priority === '最高')) return false;
      
      // 期限が設定されていて、2ヶ月以内のもののみ
      if (!task.dueDate) return false;
      const dueDate = new Date(task.dueDate);
      return dueDate <= twoMonthsLater;
    });
 
    /** 
    const thisWeekDueTasks = tasks.filter(task => {
      if (!task.dueDate || task.status === '完了') return false;
      const dueDate = new Date(task.dueDate);
      return dueDate > today && dueDate <= endOfWeek;
    });
*/
    return {
      overdue: overdueTasks,
      thisWeek: thisWeekDueTasks, // 今日〜今週を統合
      highPriority: highPriorityTasks
    };
  };

  // カテゴリ別進捗の計算
  // const calculateCategoryProgress = () => {
  //   // 実際のmockData.tsと一致するカテゴリを使用
  //   const categories = [
  //     '情報収集・計画', '式場・会場', '衣装・美容', '招待状・ペーパーアイテム',
  //     '料理・ケーキ', '装花・演出', '写真・映像', '音楽・BGM', 
  //     '引き出物・プチギフト', '交通・宿泊', '法的手続き・事務', 'その他'
  //   ];

  //   return categories.map(category => {
  //     const categoryTasks = tasks.filter(task => task.category === category);
  //     const completedCount = categoryTasks.filter(task => task.status === '完了').length;
  //     const progress = categoryTasks.length > 0 ? Math.round((completedCount / categoryTasks.length) * 100) : 0;

  //     return {
  //       category,
  //       total: categoryTasks.length,
  //       completed: completedCount,
  //       progress
  //     };
  //   }); // .filter(item => item.total > 0) を削除 - 全カテゴリを表示
  // };

  const urgentTasks = calculateUrgentTasks();
 // const categoryProgress = calculateCategoryProgress();

  // 緊急タスクリストの描画
  const renderUrgentTaskList = (taskList: any[], type: 'overdue' | 'thisWeek' | 'highPriority') => {
    if (taskList.length === 0) {
      return (
        <p className="text-xs text-gray-400 text-center py-2">該当なし</p>
      );
    }

    const iconMap = {
      overdue: 'fas fa-exclamation-circle text-red-500',
      thisWeek: 'fas fa-calendar-week text-yellow-500',
      highPriority: 'fas fa-star text-orange-500'
    };

    // 期限日フォーマット関数
    const formatDate = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getMonth() + 1}/${date.getDate()}`;
    };

    // 期限の早い順にソート（期限なしは最後）
    const sortedTaskList = [...taskList].sort((a, b) => {
      // 期限なしのタスクは最後に
      if (!a.dueDate && !b.dueDate) return 0;
      if (!a.dueDate) return 1;
      if (!b.dueDate) return -1;
      
      // 期限日で昇順ソート（早い順）
      return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
    });

    // 表示件数を15件に増加、スマホ対応の動的高さ設定
    const displayCount = 15;

    return (
      <div 
        className="mt-2 text-left px-2 urgent-tasks-container"
        style={{
          // インラインスタイルでスクロール動作を強制
          WebkitOverflowScrolling: 'auto', // touchを避ける
          touchAction: 'pan-y'
        }}
      >
        {sortedTaskList.slice(0, displayCount).map((task, index) => (
          <div 
            key={task.taskId || task.id || `${type}-task-${index}`} 
            className="urgent-task-item hover:bg-gray-50 cursor-pointer transition-colors group p-2 rounded"
            onClick={() => setEditingTask(task)}
            title="クリックして編集"
            style={{ touchAction: 'manipulation' }} // タップ遅延防止
          >
            <i className={iconMap[type]}></i>
            <span className="flex-1 group-hover:text-pink-600 transition-colors">
              {task.name}
              <span className="ml-2 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity">
                ✏️
              </span>
            </span>
            {/* 全てのタスクタイプで期限日を表示 */}
            {task.dueDate && (
              <span className="ml-2 text-xs bg-gray-100 text-gray-700 px-1 py-0.5 rounded">
                {formatDate(task.dueDate)}
              </span>
            )}
          </div>
        ))}
        {sortedTaskList.length > displayCount && (
          <div className="text-xs text-gray-400 text-center py-1">
            他 {sortedTaskList.length - displayCount} 件
          </div>
        )}
      </div>
    );
  };

  return (
   // <div className="space-y-3 sm:space-y-8 px-2 sm:px-0 pb-32 md:pb-24">
    <div className="min-h-screen space-y-2 sm:space-y-6 px-3 sm:px-6 md:px-0 pb-24 sm:pb-32 md:pb-24">
      {/* ページタイトル - モバイル最適化 */}
      <div className="text-center mb-2 sm:mb-4">
        <div className="flex items-center justify-center mb-1 sm:mb-2">
          <span className="text-lg sm:text-2xl md:text-4xl mr-1 sm:mr-2 md:mr-3">🏠</span>
          <h2 className="text-base sm:text-xl md:text-3xl font-bold text-gray-800">ダッシュボード</h2>
        </div>
        <p className="text-xs sm:text-sm md:text-base text-gray-600">結婚式準備の進捗状況を確認しましょう</p>
      </div>

 
      {/* 重要度ベースのタスク */}
      <div className="mb-3 sm:mb-6">
        <h3 className="text-sm sm:text-base md:text-xl font-semibold text-orange-500 mb-2 sm:mb-3">⭐ 重要度の高いタスク</h3>
        <div className="w-full">
          {/* 重要度高（2ヶ月以内期限） */}
          <div className="dashboard-metric card-enhanced bg-orange-50 border border-orange-200 mx-0">
            <div className="flex justify-center items-baseline p-2 sm:p-4">
              <div className="dashboard-metric-value text-orange-500 text-lg sm:text-xl">{urgentTasks.highPriority.length}</div>
              <span className="text-orange-500 ml-1 text-xs sm:text-sm">件</span>
            </div>
            <div className="dashboard-metric-label text-xs sm:text-sm">重要度高 (2ヶ月以内期限)</div>
            {renderUrgentTaskList(urgentTasks.highPriority, 'highPriority')}
          </div>
        </div>
      </div>

      {/* 期限ベースの緊急タスク */}
      <div className="mb-3 sm:mb-6">
        <h3 className="text-sm sm:text-base md:text-xl font-semibold text-red-500 mb-2 sm:mb-3">🚨 期限ベースの緊急タスク</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4 mx-0">
          {/* 期限切れ */}
          <div className="dashboard-metric card-enhanced bg-red-50 border border-red-200">
            <div className="flex justify-center items-baseline p-2 sm:p-4">
              <div className="dashboard-metric-value text-red-500 text-lg sm:text-xl">{urgentTasks.overdue.length}</div>
              <span className="text-red-500 ml-1 text-xs sm:text-sm">件</span>
            </div>
            <div className="dashboard-metric-label text-xs sm:text-sm">期限切れ (未完了)</div>
            {renderUrgentTaskList(urgentTasks.overdue, 'overdue')}
          </div>

          {/* 今日〜今週期限（統合） */}
          <div className="dashboard-metric card-enhanced bg-yellow-50 border border-yellow-200">
            <div className="flex justify-center items-baseline p-2 sm:p-4">
              <div className="dashboard-metric-value text-yellow-500 text-lg sm:text-xl">{urgentTasks.thisWeek.length}</div>
              <span className="text-yellow-500 ml-1 text-xs sm:text-sm">件</span>
            </div>
            <div className="dashboard-metric-label text-xs sm:text-sm">今週期限 (未完了)</div>
            {renderUrgentTaskList(urgentTasks.thisWeek, 'thisWeek')}
          </div>
        </div>
      </div>
      {/* タスク編集モーダル */}
      {editingTask && (
        <EditTaskModal
          task={editingTask}
          onClose={() => setEditingTask(null)}
        />
      )}
     {/* ステータス概要 - コンパクト水平レイアウト */}
     <div className="card-enhanced bg-white rounded-lg shadow-sm border border-gray-200 p-2 sm:p-3 md:p-4 mb-3 sm:mb-6 mx-0">
        <div className="flex items-center justify-between dashboard-status-compact">
          <div className="flex items-center space-x-2 sm:space-x-4 md:space-x-6">
        <div className="text-center">
              <div className="text-sm sm:text-lg md:text-xl font-bold text-green-600">
                {tasks.filter(t => t.status === '完了').length}
              </div>
              <div className="text-xs text-gray-600">完了</div>
          </div>
          
            <div className="text-center">
              <div className="text-sm sm:text-lg md:text-xl font-bold text-yellow-600">
                {tasks.filter(t => t.status === '進行中').length}
              </div>
              <div className="text-xs text-gray-600">進行中</div>
            </div>
            
            <div className="text-center">
              <div className="text-sm sm:text-lg md:text-xl font-bold text-gray-600">
                {tasks.filter(t => t.status === '未着手').length}
              </div>
              <div className="text-xs text-gray-600">未着手</div>
            </div>
          </div>

          <div className="text-right">
            <div className="text-base sm:text-xl md:text-2xl font-bold text-pink-600">
              {tasks.length}
            </div>
            <div className="text-xs text-gray-600">総タスク</div>
          </div>
        </div>
        
        {/* 進捗バー */}
        <div className="mt-2 sm:mt-3">
          <div className="flex justify-between items-center mb-1">
            <span className="text-xs text-gray-600">全体進捗</span>
            <span className="text-xs font-semibold text-pink-600">
              {tasks.length > 0 ? Math.round((tasks.filter(t => t.status === '完了').length / tasks.length) * 100) : 0}%
            </span>
          </div>
          <div className="progress-bar-bg !h-2">
            <div 
              className="progress-bar !h-2" 
              style={{
                width: `${tasks.length > 0 ? Math.round((tasks.filter(t => t.status === '完了').length / tasks.length) * 100) : 0}%`
              }}
            />
          </div>
        </div>
      </div>
      
      {/* カテゴリ別進捗 - モバイル最適化 */}
      
      {/* <div>
        <h3 className="text-base sm:text-xl font-semibold text-pink-500 mb-2 sm:mb-4">カテゴリ別進捗</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-2 sm:gap-x-6 gap-y-1 sm:gap-y-3">
          {categoryProgress.map((item) => {
            // 実際のカテゴリに合わせた色設定
            const categoryColors = {
              '情報収集・計画': { bg: 'bg-cyan-100', text: 'text-cyan-700' },
              '式場・会場': { bg: 'bg-green-100', text: 'text-green-700' },
              '衣装・美容': { bg: 'bg-purple-100', text: 'text-purple-700' },
              '招待状・ペーパーアイテム': { bg: 'bg-blue-100', text: 'text-blue-700' },
              '料理・ケーキ': { bg: 'bg-yellow-100', text: 'text-yellow-700' },
              '装花・演出': { bg: 'bg-indigo-100', text: 'text-indigo-700' },
              '写真・映像': { bg: 'bg-pink-100', text: 'text-pink-700' },
              '音楽・BGM': { bg: 'bg-amber-100', text: 'text-amber-700' },
              '引き出物・プチギフト': { bg: 'bg-teal-100', text: 'text-teal-700' },
              '交通・宿泊': { bg: 'bg-orange-100', text: 'text-orange-700' },
              '法的手続き・事務': { bg: 'bg-gray-200', text: 'text-gray-700' },
              'その他': { bg: 'bg-slate-200', text: 'text-slate-700' }
            };

            const colors = categoryColors[item.category as keyof typeof categoryColors] || categoryColors['その他'];

            // プログレスバーの色を決定
            const getProgressColor = () => {
              if (colors.text.includes('cyan')) return '#0891b2';
              if (colors.text.includes('green')) return '#16a34a';
              if (colors.text.includes('purple')) return '#9333ea';
              if (colors.text.includes('yellow')) return '#ca8a04';
              if (colors.text.includes('blue')) return '#2563eb';
              if (colors.text.includes('indigo')) return '#4f46e5';
              if (colors.text.includes('pink')) return '#ec4899';
              if (colors.text.includes('amber')) return '#d97706';
              if (colors.text.includes('teal')) return '#0d9488';
              if (colors.text.includes('orange')) return '#ea580c';
              if (colors.text.includes('slate')) return '#64748b';
              return '#6b7280';
            };

            return (
              <div key={item.category} className="category-progress-item mb-3">
                <div className="flex justify-between items-start mb-2">
                  <div className="flex-1 min-w-0 pr-2">
                    <span className={`font-medium text-sm sm:text-base break-words leading-tight ${colors.text}`}>
                      {item.category}
                    </span>
                    <div className="text-xs text-gray-500 mt-1">
                      {item.completed}/{item.total} 完了
                  </div>
                  </div>
                  <div className="flex-shrink-0">
                    <span className={`text-sm font-semibold ${colors.text}`}>{item.progress}%</span>
                  </div>
                </div>
                <div className="progress-bar-bg !h-2">
                  <div 
                    className="progress-bar !h-2" 
                    style={{
                      width: `${item.progress}%`,
                      backgroundColor: getProgressColor()
                    }}
                  />
            </div>
          </div>
            );
          })}
            </div>
          </div> */}
    </div>
  
  );
};

export default Dashboard;